module.exports = __webpack_public_path__ + "static/img/404.01726f0a.png";